const globalConfig = {
      serverUrl: "https://business.dongkuntech.cn/api/v1",
      localUrl: 'https://ads.dongkuntech.cn',
}
export default globalConfig
